import React from "react";
import { Col, Row } from "react-bootstrap";
import { ProductReferenceField } from "../../CompoundFields/ProductReferenceField";
import { DescriptionField } from "../../CompoundFields/DescriptionField";
import { ContentLanguageForm } from "../../Parts/ContentLanguageForm";
import { Condition } from "../../Conditionals/Condition";
import { TranslationForm } from "../../Parts/TranslationForm";
import { SpecialForm } from "../../Parts/SpecialForm";
// import { PrintForm } from "../../Parts/PrintForm";

export const RollUp = () => {
    return <Row>
        <hr/>
        <Col md={ 12 }>
            <h2>Roll Up</h2>
            <ProductReferenceField
                elementType="roll up"
            />
        </Col>

        <DescriptionField
            parent="Roll up"
        />

        <ContentLanguageForm
            elementType="roll up"
        />

        <Condition when="Content Language Option" is="Translation">
            <TranslationForm
                elementType="roll up"
            />
        </Condition>
        <Condition when="Content Language Option" is="Special">
            <SpecialForm/>
        </Condition>

        {/*<PrintForm/>*/}
    </Row>;
}